import { styled, css } from 'styled-components';
export const Container = styled.div.withConfig({
  componentId: "aui__sc-w37oz0-0"
})(["", " display:flex;", ""], ({
  $shouldGrow
}) => $shouldGrow && `flex-grow: 1;`, getFlex);
export const Super = styled.sup.withConfig({
  componentId: "aui__sc-w37oz0-1"
})(["vertical-align:top;font-size:0.6em;"]);
function getFlex({
  $alignment
}) {
  if ($alignment === 'stack') {
    return css(["flex-direction:column;align-items:flex-start;justify-content:flex-end;"]);
  } else {
    // support deprecated $alignment prop
    return css(["flex-direction:", ";gap:var(--aui-spacing-100);align-items:flex-end;"], {
      wrap: 'row',
      'wrap-reverse': 'row-reverse',
      'stack-reverse': 'column-reverse'
    }[$alignment]);
  }
}